interface UrgencyBannerProps {
  scrollToForm: () => void;
}

export default function UrgencyBanner({ scrollToForm }: UrgencyBannerProps) {
  return (
    <section className="py-12 sm:py-14 lg:py-16 xl:py-20 bg-gradient-to-r from-[#E91E63]/10 via-[#E91E63]/5 to-transparent border-t-4 border-[#E91E63]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="w-20 h-20 flex items-center justify-center bg-[#E91E63] rounded-full mx-auto mb-6">
          <i className="ri-time-line text-white text-4xl"></i>
        </div>

        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-black mb-4">
          Condição Especial por Tempo Limitado
        </h2>

        <p className="text-lg sm:text-xl text-red-600 font-semibold mb-6 sm:mb-8">
          Vagas limitadas por agenda semanal
        </p>

        <div className="space-y-4 mb-8 max-w-2xl mx-auto">
          <div className="flex items-center justify-center gap-3">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 bg-[#E91E63] rounded-full">
              <i className="ri-check-line text-white text-sm"></i>
            </div>
            <p className="text-base sm:text-lg text-gray-700">Avaliação gratuita disponível apenas para novos clientes em Paulínia</p>
          </div>
          <div className="flex items-center justify-center gap-3">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 bg-[#E91E63] rounded-full">
              <i className="ri-check-line text-white text-sm"></i>
            </div>
            <p className="text-base sm:text-lg text-gray-700">Garanta sua avaliação antes do encerramento das vagas</p>
          </div>
        </div>

        <button 
          onClick={scrollToForm}
          className="bg-[#E91E63] hover:bg-[#C2185B] text-white font-bold text-base sm:text-lg px-8 sm:px-10 py-4 sm:py-5 rounded-2xl transition-all duration-300 hover:scale-105 shadow-xl shadow-[#E91E63]/40 w-full sm:w-auto cursor-pointer"
        >
          Garantir Minha Vaga Agora
        </button>
      </div>
    </section>
  );
}
